import ProjectList from "./ProjectList";

export default function Portfolio({ projects }) {
  return <ProjectList projects={projects} />;
}
